import { Checkbox } from "@mui/material";

interface IKeyDriveCheckbox {
    onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
    value?: any;
    checked?: boolean
}

function KeyDriveCheckbox({
    onChange,
    value,
    checked = false
}: IKeyDriveCheckbox) {
    return (
        <Checkbox 
            checked={checked}
            onChange={onChange}
            sx={{
                color: "#22638D"
            }}
            value={value}
        />
    );
}

export default KeyDriveCheckbox;